import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../../components/Layout'
import { CHANGE_DEFECTIVE_GROUPS_PAGE } from '../../store/types'
import PagnationComponent from '../../components/PagnationComponent'
import { Button, Container, Typography } from '@mui/material'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'
import SearchDefectiveGroup from '../../components/defectiveGroup/SearchDefectiveGroup'
import { getAllDefectiveGroups } from '../../store/actions/defectiveGroupAction'
import DefectiveGroupInfo from '../../components/defectiveGroup/DefectiveGroupInfo'
import { getAllDefectiveItemSuppliers } from '../../store/actions/defectiveItemAction'

const DefectiveGroups = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const defectiveGroupState = useSelector((state) => state.defectiveGroup)
    const { defectiveGroups, pages, page, count, keyword } = defectiveGroupState
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)

    useEffect(() => {
        dispatch(getAllDefectiveItemSuppliers())
    }, [dispatch])

    const pageNumber = page || 1
    useEffect(() => {
        dispatch(getAllDefectiveGroups(keyword, pageNumber))
    }, [dispatch, keyword, pageNumber])

    const changePage = useCallback(
        (page) => {
            dispatch({ type: CHANGE_DEFECTIVE_GROUPS_PAGE, payload: page })
        },
        [dispatch]
    )
    return (
        <Layout>
            <Container>
                <Button
                    color="info"
                    variant="outlined"
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.DEFECTIVE_ITEM,
                            roleType.CREATE
                        )
                            ? navigate(`/add-defective-group`)
                            : alert('Not Permit User')
                    }
                >
                    Add New Defective Group
                </Button>
                <SearchDefectiveGroup displayKeyword={keyword} />
                <Typography
                    variant="body2"
                    gutterBottom
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                    Count: {count}
                </Typography>
                {defectiveGroups && (
                    <DefectiveGroupInfo defectiveGroups={defectiveGroups} />
                )}
                <PagnationComponent
                    page={pageNumber}
                    pages={pages}
                    func={changePage}
                />
            </Container>
        </Layout>
    )
}

export default DefectiveGroups
